import React from 'react';
import Grid from '@material-ui/core/Grid';

import Success from '@components/Success';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const h2Style = {
  fontFamily: 'Roboto',
  fontSize: '24px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  marginTop: '0',
  marginBottom: '10px',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#444b62',
};

const GenericError = ({ t }) => {
  const history = useHistory();
  const { buttonTextCode, firstLineCode, shouldShowButton, subTextCode, nextPage } =
    history?.location?.state ?? {};
  return (
    <Grid container>
      <Success
        imgStyle={{ margin: 'auto', marginTop: '83px' }}
        h2Style={h2Style}
        firstLine={t(firstLineCode)}
        buttonText={t(buttonTextCode)}
        transactionsFlag
        handleClick={() => history.push(nextPage)}
        gridProds={{ justify: 'center', container: true }}
        helperText={t(subTextCode)}
        type="error"
        shouldShowButton={shouldShowButton}
      />
    </Grid>
  );
};

export default withTranslation()(GenericError);
